export const MODAL_TYPES = {
  UPS_NBNL: 'is_no_box_label_enabled',
  UPS_PAPERLESS: 'is_ups_no_label_supported'
};
